import React, { useEffect, useState } from "react";

import CardBody from "../../../components/Card/CardBody";
import Card from "../../../components/Card/Card";
import { FormLabel, GridLegacy, MenuItem, Typography } from "@mui/material";
import TranslationWrapper, { getTranslation } from "../../../components/TranslationWrapper/TranslationWrapper";

import Venue from "../../../licensing/Models/Venue";
import FormTextTC from "../../../components/Forms/FormTextTC";
import { useFormContext, useWatch } from "react-hook-form";
import FormControlledInputTC from "../../../components/Forms/FormControlledInputTC";
import FormSwitchTC from "../../../components/Forms/FormSwitchTC";
import FormSelectTC from "../../../components/Forms/FormSelectTC";
import FormAsyncTC from "../../../components/Forms/FormAsyncTC";
import { connect } from "react-redux";
import { useParams } from "react-router";

//Variabele importeren

function SubsSubscriptionGeneral(props) {
  const [venue, setVenue] = useState(null);
  const params = useParams();

  const { getValues } = useFormContext();
  const venueId = useWatch({ name: "venue_id" });
  let infoFields;
  if (params.id == null) {
    infoFields = [
      { key: "start_date", type: "date" },
      { key: "next_date", type: "date" },
      { key: "end_date", type: "date" },
      { key: "period", type: "select", options: ["MONTH", "YEAR"] },
      { key: "license_type", type: "select", options: ["MONTHLY", "YEARLY", "FLEX", "SEASON", "TRANSACTIONS"] },
      {
        key: "pay_provider",
        type: "select",
        options: [
          { value: null, label: "N/A" },
          { value: "CM", label: "CM" },
        ],
      },
      {
        key: "invoice_type",
        type: "select",
        options: [
          { value: "UPFRONT", label: "Upfront" },
          { value: "AFTERWARDS", label: "Afterwards" },
        ],
      },
      {
        key: "invoice_period",
        type: "select",
        options: [
          { value: JSON.stringify({ every: { months: 1 } }), label: "Every month" },
          { value: JSON.stringify({ every: { months: 3 } }), label: "Every 3 months" },
          { value: JSON.stringify({ every: { months: 6 } }), label: "Every half a year" },
          { value: JSON.stringify({ every: { months: 12 } }), label: "Once a year" },
        ],
      },
      { key: "force_gateway_for_free", type: "boolean" },
      { key: "create_transactions_invoice", type: "boolean" },
      {
        key: "force_invoice_gateway",
        type: "boolean",
        getExtraMessage: () => {
          return venue?.gateways_count >= 0 ? (
            <Typography style={{ fontWeight: 800 }}>{venue.gateways_count + " gateways found"}</Typography>
          ) : null;
        },
      },
      { key: "internal_notes", type: "textarea" },
      { key: "QR", type: "boolean" },
      { key: "Kiosk", type: "boolean" },
      { key: "Webshop", type: "boolean" },
      { key: "Tablets", type: "boolean" },
      { key: "Catalog", type: "boolean" },
    ];
  } else {
    infoFields = [
      { key: "start_date", type: "date" },
      // { key: "start_invoicing_date", type: "date" },
      { key: "next_date", type: "date" },
      { key: "end_date", type: "date", nullable: true },
      "payment_period_in_days",
      "block_period_in_days",
      { key: "status", type: "select", options: ["ACTIVE", "BLOCKED", "UNBLOCKED"] },
      { key: "status_invoicing", type: "select", options: ["ACTIVE", "PAUSED"] },
      { key: "period", type: "select", options: ["MONTH", "YEAR"] },
      { key: "license_type", type: "select", options: ["MONTHLY", "YEARLY", "FLEX", "SEASON", "TRANSACTIONS"] },
      {
        key: "pay_provider",
        type: "select",
        options: [
          { value: null, label: "N/A" },
          { value: "CM", label: "CM" },
        ],
      },
      {
        key: "language",
        type: "select",
        options: [
          { value: "NL", label: "Nederlands" },
          { value: "EN", label: "Engels" },
        ],
      },
      {
        key: "invoice_period",
        type: "select",
        options: [
          { value: JSON.stringify({ every: { months: 1 } }), label: "Every month" },
          { value: JSON.stringify({ every: { months: 3 } }), label: "Every 3 months" },
          { value: JSON.stringify({ every: { months: 6 } }), label: "Every half a year" },
          { value: JSON.stringify({ every: { months: 12 } }), label: "Once a year" },
        ],
      },
      {
        key: "invoice_type",
        type: "select",
        options: [
          { value: "UPFRONT", label: "Upfront" },
          { value: "AFTERWARDS", label: "Afterwards" },
        ],
      },
      { key: "force_gateway_for_free", type: "boolean" },
      { key: "create_transactions_invoice", type: "boolean" },
      {
        key: "force_invoice_gateway",
        type: "boolean",
        getExtraMessage: () => {
          return venue?.gateways_count >= 0 ? (
            <Typography style={{ fontWeight: 800 }}>{venue.gateways_count + " gateways found"}</Typography>
          ) : null;
        },
      },
      { key: "internal_notes", type: "textarea" },
    ];
  }

  const translations = {
    period: getTranslation("License Period"),
    internal_notes: getTranslation("Internal notes"),
    license_type: getTranslation("License type"),
    pay_provider: getTranslation("Transactions provider"),
    invoice_period: getTranslation("Invoice Period"),
    language: getTranslation("Invoice language"),
    start_date: getTranslation("Start date"),
    start_invoicing_date: getTranslation("Start invoicing date"),
    next_date: getTranslation("Next invoice date"),
    end_date: getTranslation("End date of License"),
    status: getTranslation("Status"),
    status_invoicing: getTranslation("Status Invoicing"),
    payment_period_in_days: getTranslation("# of days for payment"),
    block_period_in_days: getTranslation("# of days before blocking without payment"),
    force_gateway_for_free: getTranslation("Do not charge gateway, even when forced to charge"),
    create_transactions_invoice: getTranslation("Generate transactions invoice for subscription"),
    force_invoice_gateway: getTranslation("Charge gateway, even when there is no gateway"),
    invoice_type: getTranslation("Invoice Type"),
    QR: getTranslation("QR"),
    Kiosk: getTranslation("Kiosk"),
    Webshop: getTranslation("Webshop"),
    Tablets: getTranslation("Tablets"),
    Catalog: getTranslation("Catalog"),
  };

  useEffect(() => {
    if ((venueId ?? props.venue_id) > 0) {
      Venue.get(venueId ?? props.venue_id).then(({ model }) => {
        setVenue(model);
      });
    }
  }, []);

  const { setValue } = useFormContext();

  useEffect(() => {
    if (props.venue_id) {
      setValue("venue_id", props.venue_id);
    }
  }, [props.venue_id]);

  return (
    <Card>
      <CardBody>
        <h3>
          <TranslationWrapper tKey={"License information"} />
          {venue ? " " + venue.name : null}
        </h3>
        <GridLegacy container>
          {/*<FormAsyncTC*/}
          {/*  name={"venue_id"}*/}
          {/*  tKey={"Venue"}*/}
          {/*  async={{*/}
          {/*    url: "core/venue/search?fields=id as value,name as label&per_page=30",*/}
          {/*    searchField: "name",*/}
          {/*  }}*/}
          {/*/>*/}

          {infoFields.map((field) => {
            switch (field.type) {
              case "string":
                return <FormTextTC name={field.key} tKey={translations[field.key]} />;

              case "textarea":
                return (
                  <FormTextTC
                    fieldProps={{ multiline: true, rows: 5 }}
                    name={field.key}
                    tKey={translations[field.key]}
                  />
                );

              case "number":
                return <FormControlledInputTC name={field.key} tKey={translations[field.key]} type={"number"} />;

              case "date":
                return (
                  <FormControlledInputTC
                    name={field.key}
                    nullable={field.nullable ?? false}
                    tKey={translations[field.key]}
                    type={"date"}
                  />
                );

              case "boolean":
                return (
                  <>
                    <FormSwitchTC name={field.key} tKey={translations[field.key]} />
                    {field.getExtraMessage ? <FormLabel>{field.getExtraMessage()}</FormLabel> : null}
                  </>
                );

              case "select": {
                let value = getValues(field.key);

                value = typeof value === "object" ? JSON.stringify(value) : value;

                return (
                  <FormSelectTC
                    name={field.key}
                    options={field.options.map((option) => {
                      let value = typeof option === "object" ? option.value : option;

                      if (typeof value === "object") {
                        value = JSON.stringify(value);
                      }

                      let label = typeof option === "object" ? option.label : option;

                      return (
                        <MenuItem key={value} value={value}>
                          {label}
                        </MenuItem>
                      );
                    })}
                    tKey={translations[field.key]}
                    value={value}
                  />
                );
              }
            }
          })}

          <FormAsyncTC
            async={{
              url: "core/subsPricePlan/search?fields=id as value, name as label",
              searchField: "name",
              perPage: 10,
            }}
            multiple={true}
            name={"subs_price_plans__ids"}
            tKey={"Price plan"}
          />

          <FormAsyncTC
            async={{
              url: "core/subsDebtor/search?fields=id as value, company_name as label&per_page=30",
              searchField: "company_name",
            }}
            name={"subs_debtor_id"}
            tKey={"Debtor"}
          />
          <FormAsyncTC
            async={{
              url: "core/subsDebtor/search?fields=id as value, company_name as label&per_page=30",
              searchField: "company_name",
            }}
            name={"transactions_debtor_id"}
            tKey={"Transactions costs debtor"}
          />
          <FormAsyncTC
            async={{
              url: "core/subsReseller/search?fields=id as value, description as label&per_page=30",
              searchField: "description",
            }}
            name={"subs_reseller_id"}
            tKey={"Reseller"}
          />
        </GridLegacy>
      </CardBody>
    </Card>
  );
}

const mapStateToProps = (state) => {
  return {
    venue_id: state.filtersV2.venue_id?.value,
    userLocale: state.user.lang,
  };
};

export default connect(mapStateToProps)(SubsSubscriptionGeneral);
